import classNames from "classnames"
import React from "react"
import { v4 } from "uuid"

export type RadioGroupProps = {
    items: {
        label: string
        value: string
        onSelected: () => void
    }[]

    selectedValue?: string
    className?: string
}

export const RadioGroup: React.FC<RadioGroupProps> = (props) => {
    const items = props.items.map(item => {
        const domId = `radio-item-${item.value}-${v4()}`

        return (
            <div key={item.value} className="d-flex align-items-center">
                <input
                    id={domId}
                    type="radio"
                    value={item.value}
                    checked={props.selectedValue === item.value}
                    onChange={item.onSelected} />

                <label className="small ml-2" style={{ marginBottom: "2px" }} htmlFor={domId}>
                    {item.label}
                </label>
            </div>
        )
    })

    return (
        <div className={classNames(
            props.className,
            "d-flex",
            "flex-column"
        )}>
            {items}
        </div>
    )
}

